export default "__VITE_ASSET__66bae36d__"